<template>
  <el-select v-bind="$attrs"
             v-on="$listeners"
             v-loading="loading">
    <el-option
      v-for="item in options"
      :key="item.id"
      :label="item.name"
      :value="item.index">
    </el-option>
  </el-select>
</template>

<script>
  export default {
    name: 'TeamSelect',
    props: {
      teamList: {
        type: Array,
        required: true
      },
      selectAll: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        loading: false,
        positions: []
      }
    },
    computed: {
      options () {
        const options = []
        if (this.selectAll) {
          options.push({
            id: -1,
            name: '全部',
            index: -1
          })
        }
        for (const i in this.teamList) {
          options.push({
            id: this.teamList[i].id,
            name: this.teamList[i].name,
            index: Number(i)
          })
        }
        return options
      }
    }
  }
</script>
